/**
 * 根据域名计算当前配置项目
 * */
const logoMH = require('../../public/logo_4.png')
const logoLX = require('../../public/logo_lingxiu_1.png')
export default function getHostData() {
  const data = {} as { [key: string]: string }
  switch (location.host) {
    // case '192.168.10.186:9999':
    case process.env.VUE_APP_LinXiu_PLAT_URL:
      data.title = '领秀'
      data.logo = logoLX
      break
    default:
      data.title = '跨赋'
      data.logo = logoMH
      break
  }
  return data
}
